export default __webpack_public_path__ + "static/media/conteudo_extra_02.9ddf21f7.jpg";